module.exports = "<h1 mat-dialog-title>{{'LOGIN.LC_LOGIN'|translate}}</h1>\n<div mat-dialog-content [@wobble]=\"loginform.wobbleState\">\n    <login-formular #loginform [dialog]=\"dialog\"></login-formular>\n</div>\n<div mat-dialog-actions>\n    <button mat-raised-button [disabled]=\"!loginform.valid\" color=\"primary\" (click)=\"loginform.login()\">\n        {{'LOGIN.LC_LOGIN'|translate}}\n    </button>\n    <button mat-raised-button mat-dialog-close>{{'LOGIN.LC_CANCEL'|translate}}</button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/login/login.dialog.html
// module id = ./src/app/components/login/login.dialog.html
// module chunks = main